import { useMediaQuery, useTheme } from '@mui/material';

import { SummaryCardNew } from '@hapvida/hapvida-core-components';

import { TOTAL_BENEFICIARIES_SUMMARY_ITEMS } from './constants';
import type { BeneficiariesSummaryProps } from './types';

export function BeneficiariesSummary({
  summaryValues,
}: Readonly<BeneficiariesSummaryProps>) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
    noSsr: true,
  });

  return (
    <SummaryCardNew.Container success>
      <SummaryCardNew.Content
        perLine={isMobile ? 2 : TOTAL_BENEFICIARIES_SUMMARY_ITEMS.length}
        summary={TOTAL_BENEFICIARIES_SUMMARY_ITEMS}
        summaryValues={summaryValues}
        pillColor
      />
    </SummaryCardNew.Container>
  );
}
